import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type SpeedProps = MeasurementProps<'speed'>;

/** How fast something is travelling. Kilometres or miles per hour, or metres per second. */
const Speed = createMeasurement('speed', 'Speed');

export default Speed;
